var url_domain = window.location.host;
var config_url = '';


//DEVS
if (url_domain.includes('192.168.1.105:8080')) {
  //config_url = 'http://127.0.0.1:3333/api/1.0'; 
  config_url = 'https://apiamidriver.myticktap.com/api/1.0';
  // config_url = 'https://apidriver.amidrivers.com/api/1.0';  

}

//MOBIL
else if (url_domain.includes('192.168.0.108:8080')) {
  config_url = 'https://apiamidriver.myticktap.com/api/1.0';

}

//QUALITY
else if (url_domain == 'amidriver.myticktap.com') {
  config_url = 'https://apiamidriver.myticktap.com/api/1.0';
}

//PRODUCTION
else if (url_domain == 'driver.amidrivers.com') {

  config_url = 'https://apidriver.amidrivers.com/api/1.0';

}
else if (url_domain == 'driver.amidrivers.net') {

  config_url = 'https://apidriver.amidrivers.net/api/1.0';

}
console.log('Backend Conected: ' + config_url)
export const apiPath = config_url;
export const appVersion = 'V.1.1.0';
